var productItems =[
    {
      "_id": "1",
      "image": "json-server",
      "name": "Margherita",
      "size":"SMALL",
      "price":"250"
    },
    {
      "_id": "2",
      "image": "json-server",
      "name": "Marinara",
      "size":"MEDIUM",
      "price":"300"
    },
    {
      "_id": "3",
      "image": "json-server",
      "name": "Chicken Mushroom",
      "size":"Medium",
      "price":"350"
    },
    {
      "_id": "4",
      "image": "json-server",
      "name": "Paneer Pizza",
      "size":"SMALL",
      "price":"150"
    },
    {
      "_id": "5",
      "image": "json-server",
      "name": "Loaded Veg",
      "size":"Large",
      "price":"600"
    },
    {
      "_id": "6",
      "image": "json-server",
      "name": "Carbonara",
      "size":"SMALL",
      "price":"250"
    },
    {
      "_id": "7",
      "image": "json-server",
      "name": "Pepperoni",
      "size":"Large",
      "price":"600"
    }
];

module.exports = {productItems}
